<div class="d-flex justify-content-center mt-8x">
    <div [ngClass]="{'no-data' : this.status == 503}" class="pl-1x">
        <div *ngIf="this.status === '503'" id="no-connection"></div>
        <h2 id="error-title">{{ 'FRAGEBOEGEN_APP.GLOBAL_ERROR.TITLE' | translate }}</h2>
        <span [ngClass]="{'reload' : this.status ==='503'}" id="error-message">
            {{ message | translate }}
        </span>
        <div *ngIf="!secondMessage" class="mt-2x ml-0 mb-2x">
            <a class="btn-link" id="navigateToUebersicht" role="link" (click)="navigateToOverview()">
                {{ linkLabel | translate }}
            </a>
        </div>
        <div *ngIf="this.status === '503'" class="mt-3x">
            <div class="mb-5x">
                <span>{{ secondMessage | translate }}</span>
                <a class="info-link" [attr.href]="linkValue">{{ linkLabel | translate }}</a>
            </div>
            <a class="reload-link" routerLink="/">{{ landingpageLinkText | translate }}</a>
        </div>
        <a *ngIf="secondMessage && this.status !== '503'" [attr.href]="linkValue">{{ linkLabel | translate }}</a>
        <p *ngIf="this.status !== '503'">{{ secondMessage | translate: {status: status} }}</p>
    </div>
</div>
<common-ui-footer></common-ui-footer>
